import { useSettingStore } from "../../features/settings/store/settingStore";

export const toLocalISOString = (date: Date): string => {
  // Use UTC methods to get the correct UTC time
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const day = String(date.getUTCDate()).padStart(2, "0");
  const hours = String(date.getUTCHours()).padStart(2, "0");
  const minutes = String(date.getUTCMinutes()).padStart(2, "0");
  const seconds = String(date.getUTCSeconds()).padStart(2, "0");
  const milliseconds = String(date.getUTCMilliseconds()).padStart(3, "0");

  const isoString = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;
  return isoString;
};

export const DATE_FORMATS: { format: string, rcFormat: string }[] = [
  {
    format: "DD-MM-YYYY",
    rcFormat: "dd-MM-yyyy",
  },
  {
    format: "DD-MMM-YYYY",
    rcFormat: "dd-MMM-yyyy",
  },
  {
    format: "DD-MMMM-YYYY",
    rcFormat: "dd-MMMM-yyyy",
  },
  {
    format: "MM-DD-YYYY",
    rcFormat: "MM-dd-yyyy",
  },
  {
    format: "MMM-DD-YYYY",
    rcFormat: "MMM-dd-yyyy",
  },
  {
    format: "MMMM-DD-YYYY",
    rcFormat: "MMMM-dd-yyyy",
  },
  {
    format: "YYYY-MM-DD",
    rcFormat: "yyyy-MM-dd",
  },
  {
    format: "DD-MMMM",
    rcFormat: "dd-MMMM",
  }
];

export const TIME_FORMATS: { format: string, rcFormat: string }[] = [
  {
    format: "HH:mm",
    rcFormat: "HH:mm",
  },
  {
    format: "H:mm",
    rcFormat: "H:mm",
  },
  {
    format: "HH:mm A",
    rcFormat: "hh:mm tt",
  },
  {
    format: "H:mm A",
    rcFormat: "h:mm tt",
  },
  {
    format: "hh:mm A",
    rcFormat: "hh:mm tt",
  },
  {
    format: "h:mm A",
    rcFormat: "h:mm tt",
  }
];

export function convertDateFormatToRc(format: string): string {
  const dateFormat = DATE_FORMATS.find(item => item.format === format);
  return dateFormat?.rcFormat || format;
}

export function convertTimeFormatToRc(format: string): string {
  const timeFormat = TIME_FORMATS.find(item => item.format === format);
  return timeFormat?.rcFormat || format;
}

export function convertDateFormatToClient(format: string): string {
  const dateFormat = DATE_FORMATS.find(item => item.rcFormat === format);
  return dateFormat?.format || format;
}

export function convertTimeFormatToClient(format: string): string {
  const timeFormat = TIME_FORMATS.find(item => item.rcFormat === format);
  return timeFormat?.format || format;
}
